export const colors = {
  // Blue is deprecated
  blue: {
    100: { value: '#C4CEF8' },
    200: { value: '#A4B6F5' },
    300: { value: '#839FF0' },
    400: { value: '#5C88EC' },
    50: { value: '#E2E6FC' },
    60: { value: '#5E7388' },
    500: { value: '#1B73E7' },
    600: { value: '#225BB4' },
    700: { value: '#224484' },
    800: { value: '#1D2F57' },
    900: { value: '#151B2D' },
  },
  // Gray is deprecated
  gray: {
    100: { value: '#E4E7EB' },
    200: { value: '#CBD2D9' },
    300: { value: '#9AA5B1' },
    400: { value: '#7B8794' },
    50: { value: '#F5F7FA' },
    60: { value: '#DCE2E5' },
    500: { value: '#616E7C' },
    600: { value: '#52606D' },
    700: { value: '#3E4C59' },
    800: { value: '#323F4B' },
    900: { value: '#1F2933' },
  },
  // Green is deprecated
  green: {
    100: { value: '#BDE4D4' },
    200: { value: '#9BD6C0' },
    300: { value: '#78C8AB' },
    400: { value: '#4FB997' },
    50: { value: '#DEF1EA' },
    500: { value: '#00AB84' },
    600: { value: '#158668' },
    700: { value: '#1A634E' },
    800: { value: '#184235' },
    900: { value: '#12241E' },
  },
  // Navy needs to be evaluated as it is a brand color used in primary buttons,
  // not a semantic color like the others that are deprecated
  navy: {
    100: { value: '#B7BED2' },
    200: { value: '#8B96B8' },
    300: { value: '#60709F' },
    400: { value: '#364885' },
    50: { value: '#E2E6EC' },
    500: { value: '#263456' },
    600: { value: '#202B48' },
    700: { value: '#19223A' },
    800: { value: '#13192C' },
    900: { value: '#1a202c' },
  },
  // Orange is deprecated
  orange: {
    100: { value: '#FFE1CA' },
    200: { value: '#FFD1B0' },
    300: { value: '#FFC296' },
    400: { value: '#FFB179' },
    50: { value: '#FFF0E4' },
    500: { value: '#FCA463' },
    600: { value: '#D48B55' },
    700: { value: '#905F3C' },
    800: { value: '#5E402A' },
    900: { value: '#312319' },
  },
  // Red is deprecated
  red: {
    100: { value: '#FFBCB1' },
    200: { value: '#FC9A8C' },
    300: { value: '#F47768' },
    400: { value: '#EA4F46' },
    50: { value: '#FFDED7' },
    500: { value: '#DE0A26' },
    600: { value: '#AE1820' },
    700: { value: '#811A1A' },
    800: { value: '#561814' },
    900: { value: '#2E120C' },
  },
  // Marley Red is deprecated
  marleyRed: {
    50: { value: '#FACAC6' },
    100: { value: '#F9B8B4' },
    200: { value: '#F7A6A1' },
    300: { value: '#F6958E' },
    400: { value: '#F4837B' },
    500: { value: '#F2685F' },
    600: { value: '#F16055' },
    700: { value: '#F04E42' },
    800: { value: '#EE3C2F' },
    900: { value: '#ED2A1D' },
  },
  // Marley Blue is deprecated
  marleyBlue: {
    100: { value: '#E3F7FC' },
    500: { value: '#44C7E9' },
  },
  hmRed: {
    25: { value: '#fffcfc' },
    50: { value: '#fef3f2' },
    75: { value: '#feecea' },
    100: { value: '#fee4e2' },
    150: { value: '#fed9d6' },
    200: { value: '#fdcecb' },
    300: { value: '#fbaba6' },
    400: { value: '#f5685f' },
    500: { value: '#ed5046' },
    600: { value: '#da3328' },
    700: { value: '#b7271e' },
    750: { value: '#a5251c' },
    800: { value: '#97241d' },
    850: { value: '#8a221c' },
    900: { value: '#7e241e' },
    950: { value: '#440e0b' },
  },
  hmTeal: {
    25: { value: '#fbfefe' },
    50: { value: '#f2fbfa' },
    75: { value: '#e8f8f6' },
    100: { value: '#d5f2f1' },
    150: { value: '#c2ede8' },
    200: { value: '#aae5e2' },
    300: { value: '#65c9c9' },
    400: { value: '#4cb1b5' },
    500: { value: '#339499' },
    600: { value: '#26767b' },
    700: { value: '#225e63' },
    750: { value: '#20555a' },
    800: { value: '#1f4c50' },
    850: { value: '#1c4347' },
    900: { value: '#1e4043' },
    950: { value: '#0c2427' },
  },
  hmTangerine: {
    25: { value: '#fffcf8' },
    50: { value: '#fff7ed' },
    75: { value: '#fff2e2' },
    100: { value: '#ffedd5' },
    150: { value: '#ffe4c1' },
    200: { value: '#ffd9aa' },
    300: { value: '#ffb366' },
    400: { value: '#ff9533' },
    500: { value: '#ff7a00' },
    600: { value: '#e66a00' },
    700: { value: '#cc5500' },
    750: { value: '#b84d00' },
    800: { value: '#a64400' },
    850: { value: '#943d00' },
    900: { value: '#803300' },
    950: { value: '#4d1f00' },
  },
  hmGray: {
    25: { value: '#fdfdfd' },
    50: { value: '#fafafa' },
    75: { value: '#f7f7f8' },
    100: { value: '#f4f4f5' },
    150: { value: '#ececee' },
    200: { value: '#e4e4e7' },
    300: { value: '#d4d4d8' },
    400: { value: '#a1a1aa' },
    500: { value: '#71717a' },
    600: { value: '#52525b' },
    700: { value: '#3f3f46' },
    750: { value: '#333338' },
    800: { value: '#27272a' },
    850: { value: '#1f1f22' },
    900: { value: '#18181b' },
    950: { value: '#111111' },
  },
  hmBlue: {
    25: { value: '#fafcfd' },
    50: { value: '#f4f7fb' },
    75: { value: '#eef4f9' },
    100: { value: '#e7f0f7' },
    150: { value: '#d9e7f2' },
    200: { value: '#cadeed' },
    300: { value: '#9cc3dd' },
    400: { value: '#64a2c9' },
    500: { value: '#4388b4' },
    600: { value: '#316d98' },
    700: { value: '#29587b' },
    750: { value: '#275071' },
    800: { value: '#254b67' },
    850: { value: '#22435e' },
    900: { value: '#244056' },
    950: { value: '#182939' },
  },
  hmNavy: {
    25: { value: '#fcfcfe' },
    50: { value: '#f7f8fd' },
    75: { value: '#f3f5fc' },
    100: { value: '#eff2fc' },
    150: { value: '#e6ebfa' },
    200: { value: '#dae2f7' },
    300: { value: '#bcc8ee' },
    400: { value: '#94a5df' },
    500: { value: '#6b7dcc' },
    600: { value: '#364885' },
    700: { value: '#2f3d72' },
    750: { value: '#2b3768' },
    800: { value: '#28315e' },
    850: { value: '#242c54' },
    900: { value: '#20264a' },
    950: { value: '#161a30' },
  },
  hmCyan: {
    25: { value: '#f9fcfd' },
    50: { value: '#f1f8fb' },
    75: { value: '#e8f5f9' },
    100: { value: '#e0f1f6' },
    150: { value: '#cde8f0' },
    200: { value: '#b6dde8' },
    300: { value: '#8cc5d8' },
    400: { value: '#5ea8c5' },
    500: { value: '#3d8db0' },
    600: { value: '#2f7299' },
    700: { value: '#265b7f' },
    750: { value: '#235275' },
    800: { value: '#1f4a66' },
    850: { value: '#1b3f58' },
    900: { value: '#17354a' },
    950: { value: '#0f1f2c' },
  },
  hmPurple: {
    25: { value: '#fcfbfd' },
    50: { value: '#f7f5fa' },
    75: { value: '#f4f0f8' },
    100: { value: '#f0ebf5' },
    150: { value: '#e8dff0' },
    200: { value: '#ded1ea' },
    300: { value: '#c9b6db' },
    400: { value: '#ad94c5' },
    500: { value: '#8f73ae' },
    600: { value: '#745a94' },
    700: { value: '#5f487a' },
    750: { value: '#564070' },
    800: { value: '#4d3a62' },
    850: { value: '#433154' },
    900: { value: '#392847' },
    950: { value: '#23172b' },
  },
};

export const colorTokens = {
  // Navy needs to be evaluated as it is a brand color used in primary buttons,
  // not a semantic color like the others that are deprecated
  navy: {
    solid: { value: '{colors.navy.500}' },
    contrast: { value: 'white' },
    fg: { value: '{colors.navy.700}' },
    muted: { value: '{colors.navy.50}' },
    subtle: { value: '{colors.navy.200}' },
    emphasized: { value: '{colors.navy.300}' },
    focusRing: { value: '{colors.navy.500}' },
  },
  // Marley Red is deprecated
  marleyRed: {
    solid: { value: '{colors.marleyRed.500}' },
    contrast: { value: 'white' },
    fg: { value: '{colors.marleyRed.700}' },
    muted: { value: '{colors.marleyRed.50}' },
    subtle: { value: '{colors.marleyRed.200}' },
    emphasized: { value: '{colors.marleyRed.300}' },
    focusRing: { value: '{colors.marleyRed.500}' },
  },
  info: {
    solid: { value: '{colors.hmBlue.600}' },
    contrast: { value: 'white' },
    fg: { value: '{colors.hmBlue.850}' },
    subtle: { value: '{colors.hmBlue.50}' },
    muted: { value: '{colors.hmBlue.75}' },
    emphasized: { value: '{colors.hmBlue.100}' },
  },
  danger: {
    solid: { value: '{colors.hmRed.600}' },
    contrast: { value: 'white' },
    fg: { value: '{colors.hmRed.850}' },
    subtle: { value: '{colors.hmRed.50}' },
    muted: { value: '{colors.hmRed.75}' },
    emphasized: { value: '{colors.hmRed.100}' },
  },
  warning: {
    solid: { value: '{colors.hmTangerine.600}' },
    contrast: { value: 'white' },
    fg: { value: '{colors.hmTangerine.850}' },
    subtle: { value: '{colors.hmTangerine.50}' },
    muted: { value: '{colors.hmTangerine.75}' },
    emphasized: { value: '{colors.hmTangerine.100}' },
  },
  success: {
    solid: { value: '{colors.hmTeal.500}' },
    contrast: { value: 'white' },
    fg: { value: '{colors.hmTeal.800}' },
    subtle: { value: '{colors.hmTeal.50}' },
    muted: { value: '{colors.hmTeal.75}' },
    emphasized: { value: '{colors.hmTeal.100}' },
  },
  ai: {
    solid: { value: '{colors.hmPurple.600}' },
    contrast: { value: '{colors.white}' },
    fg: { value: '{colors.hmPurple.850}' },
    subtle: { value: '{colors.hmPurple.50}' },
    muted: { value: '{colors.hmPurple.75}' },
    emphasized: { value: '{colors.hmPurple.100}' },
  },
  neutral: {
    solid: { value: '{colors.hmGray.700}' },
    contrast: { value: '{colors.white}' },
    fg: { value: '{colors.hmGray.900}' },
    subtle: { value: '{colors.hmGray.50}' },
    muted: { value: '{colors.hmGray.75}' },
    emphasized: { value: '{colors.hmGray.100}' },
  },
  bg: {
    error: {
      value: '{colors.danger.subtle}',
    },
    warning: {
      value: '{colors.warning.subtle}',
    },
    success: {
      value: '{colors.success.subtle}',
    },
    info: {
      value: '{colors.info.subtle}',
    },
    ai: {
      value: '{colors.ai.subtle}',
    },
    surface: {
      lv0: {
        value: '{colors.white}',
      },
      lv1: {
        value: '{colors.hmGray.50}',
      },
      lv2: {
        value: '{colors.hmGray.100}',
      },
    },
  },
  fg: {
    error: {
      value: '{colors.danger.fg}',
    },
    warning: {
      value: '{colors.warning.fg}',
    },
    success: {
      value: '{colors.success.fg}',
    },
    info: {
      value: '{colors.info.fg}',
    },
    ai: {
      value: '{colors.ai.fg}',
    },
  },
  border: {
    error: {
      value: '{colors.danger.emphasized}',
    },
    warning: {
      value: '{colors.warning.emphasized}',
    },
    success: {
      value: '{colors.success.emphasized}',
    },
    info: {
      value: '{colors.info.emphasized}',
    },
    ai: {
      value: '{colors.ai.emphasized}',
    },
  },
};

export default colors;
